import { UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import LocationContacts from '../../location-contacts/LocationContacts';
import { useAlarmGroupTracking } from '../../unified-alarm-group/useAlarmGroupTracking';
import { SnapshotUploader } from './SnapshotUploader';
interface Props {
  siteAddress: string;
  escalationPoints: string[];
  escalationProtocol: string[];
  locationId: string;
  locationTenantId?: string;
  locationAlarmId?: string;
  alarmGroupId?: string;
  escalationId?: string;
  product?: UnifiedMonitoringProduct;
  mapEmbedUrl?: string;
  timezone?: string;
}

export function Escalation(props: Props) {
  const {
    siteAddress,
    escalationPoints,
    escalationProtocol,
    locationId,
    locationTenantId,
    locationAlarmId,
    alarmGroupId,
    escalationId,
    product,
    mapEmbedUrl,
    timezone,
  } = props;
  const track = useAlarmGroupTracking();

  return (
    <div className="flex flex-col gap-4 px-2 pt-2">
      <h2 className="text-center font-semibold text-red-700/80 dark:text-red-400/80">
        Escalate now to concerned authorities
      </h2>
      {locationAlarmId && (
        <SnapshotUploader
          locationAlarmId={locationAlarmId}
          product={product}
          timezone={timezone}
          onUploadSuccess={(action) =>
            track('alarm_group_sop_add_event', { action })
          }
        />
      )}
      <div className="flex flex-col gap-1">
        <div className="flex gap-2">
          <span className="text-primary-800 dark:text-primary-400 font-sans font-semibold">
            Site address:
          </span>
          <span className="text-sm">{siteAddress || '—'}</span>
        </div>

        {mapEmbedUrl && (
          <div className="relative h-36 overflow-hidden rounded-lg">
            <iframe
              src={mapEmbedUrl}
              title="Site location map"
              className="absolute left-0 top-0 h-56 w-[800px] origin-top-left scale-[0.65]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </div>

      {escalationProtocol.length > 0 && (
        <div className="space-y-2">
          <div className="text-primary-800 dark:text-primary-400 font-sans font-semibold">
            Escalation Protocol:
          </div>
          <ol className="ml-4 list-decimal space-y-1 text-sm">
            {escalationProtocol.map((point, i) => (
              <li key={i} className="[overflow-wrap:anywhere]">
                {point}
              </li>
            ))}
          </ol>
        </div>
      )}
      <div className="space-y-2">
        <details>
          <summary className="text-primary-800 dark:text-primary-400 cursor-pointer font-sans font-semibold">
            Call Checklist
          </summary>
          <ol className="mt-2 list-decimal space-y-1 text-sm">
            {escalationPoints.map((point, i) => (
              <li key={i} className="[overflow-wrap:anywhere]">
                {point}
              </li>
            ))}
          </ol>
        </details>
      </div>
      <div className="pt-2">
        <LocationContacts
          key={escalationId || 'no-escalation'}
          locationId={+locationId}
          locationTenantId={locationTenantId}
          locationAlarmId={locationAlarmId}
          alarmGroupId={alarmGroupId}
          escalationId={escalationId}
          product={product}
          timezone={timezone}
        />
      </div>
    </div>
  );
}

export default Escalation;
